<template>
    <div>
        <a-card>
            <div v-if="state === '0'" class="text-center" style="margin: 40px 0"  >
                <img style="margin: auto;width: 90px" src="../../img/empty2.png">
                <div class="size2 mt-3 color-ash">竞价未开始</div>
                <a class="mt-2 d-block" href="javascript:;" @click="onSimulation(1)" v-if="showExercise">模拟自由竞价练习</a>
                <a class="mt-5 d-block" href="javascript:;" @click="onSimulation(2)" v-if="showExerciseSingle">模拟单轮竞价练习</a>
            </div>
            <div v-else class="text-center" style="margin: 40px 0">
                <img style="margin: auto;width: 90px" src="../../img/empty2.png">
                <!-- 未开标 0 竞价中 1  竞价结束 2 未发公告 3 -->
                <div class="size2 mt-3 color-ash">{{code==0?"竞价未开始":code==1?"竞价已开始":"竞价结束"}}</div>
                <a-button type="primary" size="large"  @click="jingjiaLobby" :disabled="code==0"  class="mt-5">{{code==0?"竞价未开始":code==1?"进入竞价大厅":"查看竞价情况"}}</a-button>
            </div>
            <div style="font-size:18px;">
              <div> 已报名参加竞价的包组：<span style="color:red;">{{ signedJoin }}</span> </div>
              <div  v-if="notBondPay" class="mt-1">还未缴纳保证金的包组：<span style="color:red"><span style="font-weight:bold;">{{notBondPay}}</span>（竞价开始前仍未缴纳的，无法参与该包组竞价）</span></div>
              <div  v-if="needQuotationConfirm" class="mt-1">需在报价大厅报价时上传报价确认函的包组：<span style="color:red"><span style="font-weight:bold;">{{needQuotationConfirm}}</span>（需提前编制并打印报价确认函文件并盖章，准备好电子扫描文件）</span></div>

            </div>
            <!-- <a-tabs >
                <template >
                <a-tab-pane v-for="it in packsList"   :key="it.id" v-if="state === '1'">
                    <div class="tab-a" slot="tab">
                        {{it.title}}
                    </div>
                    <div v-if="it.jingjiaWay === '1'">
                        <FreedomCompete :packId="it.id" ></FreedomCompete>
                    </div>
                    <div v-else-if="it.jingjiaWay === '2'">
                        <SingleCompete :packId="it.id"></SingleCompete>
                    </div>
                </a-tab-pane>
                </template>
            </a-tabs> -->
        </a-card>
    </div>
</template>

<script>
    import FreedomCompete from './FreedomCompete'
    import FreedomCompete2 from './FreedomCompete2'
    import SingleCompete from './SingleCompete'
    import Clock from 'vue-clock2';
    import CountDown from '@/components/CountDown/CountDown'
    import qs from 'qs'

    export default {
        name: "CompeteHome",
        components: {
            FreedomCompete,
            FreedomCompete2,
            SingleCompete,
            Clock,
            CountDown
        },
        created() {
            this.getBeginState2()
        },
        props: {
            projectId: {
                type: String,
                required: true,
                default: ''
            },
        },
        destroyed() {
            clearInterval(this.beginTimer)
        },
        data() {
            return {
                deadline: Date.now() + 1000 * 60 * 60 * 24 * 2 + 1000 * 30,
                packsList:[],
                timer:new Date(),
                serverDate:'',
                beginDate:'',
                beginTimer: '',
                state:'1',
                disparity:'',
                changeDisparityTimer: '',
                code:0,
                notBondPay:"",
                needQuotationConfirm: '',
                signedJoin:"",
                showExercise:false,
                showExerciseSingle:false
            }
        },
        methods: {
            initPacks() {
                let that = this
                this.$http.get("/api/v1/supplier/packs/getSignedPacks.json?projectId=" + this.projectId).then(function (res) {
                    that.packsList = res.result.list
                    for (let i = 0; i < that.packsList.length; i++) {
                        that.packsList[i].title = that.packsList[i].extras.packName
                        if(that.packsList[i].jingjiaWay=='1'){
                            that.showExercise=true
                        }else{
                            that.showExerciseSingle=true
                        }
                    }
                });
                clearInterval(that.changeDisparityTimer)
            },
            getBeginState2() {
                let that = this
                this.$http.get('/api/v1/supplier/compete/getBeginDate.json?projectId='+this.projectId).then(function (res) {
                    that.beginDate = res.beginDate
                    that.serverDate = res.serverDate
                    that.disparity = res.disparity
                    that.notBondPay =res.notBondPay
                    that.needQuotationConfirm = res.needQuotationConfirm
                    that.signedJoin =res.signedJoin
                    that.code = res.code
                    if (that.disparity > 0){ //未开标
                        that.state = '0'
                        that.changeDisparityTimer = setInterval(that.changeDisparity,1000)
                        that.initPacks()
                    }else {//已开标
                        that.state = '1'
                        that.initPacks()
                    }
                });
            },
            changeDisparity() {
                this.disparity = this.disparity - 1000
                if (this.disparity < 0) {
                    this.state = '1'
                    this.initPacks()
                    // this.getBeginState2()
                }
            },
            onSimulation(type) {
              let path ="";
              if(type==1){
                path="/compete/SimulationCompete"
              }else{
                path="/compete/SimulationSingleCompete"
              }
                let routeIndex = this.$router.resolve({
                    path: path
                })
                window.open(routeIndex.href, '_blank')
            },
            jingjiaLobby(){
                //设置竞价项目办理状态为30-竞价中
                let that = this;
                // console.log(this.code,"state"+this.state)
                if(this.code==1 && this.state=='1'){
                    let data = {
                    projectId:this.projectId,
                    cgfs:"1",
                    status:'30'
                    }
                    that.$http.post("/api/v1/supplier/compete/editBidXmBlZt.json",qs.stringify(data))
                        .then(function (response) {
                    });
                }
                let routeIndex =this.$router.resolve({
                        path:"/compete/competitive?projectId="+this.projectId+"&code="+this.code
                })
                window.open(routeIndex.href,"_self")
            }
        }
    }
</script>

<style lang="less" scoped>


    .bubble {
        position: absolute;
        display: inline-block;
        border: 1px solid #ff0000;
        color: #ff0000;
        background-color: #fff;
        padding: 0 6px;
        border-radius: 4px;
        font-size: 12px;
        line-height: 22px;
        top: 0;
        transform: scale(0.8);
        right: -20px;
        width: 36px;
        box-sizing: content-box;
        text-align: center;
    }
    .bubble::before {
        content: "";
        position: absolute;
        bottom: -12px;
        left: 6px;
        display: block;
        height: 0;
        width: 0;
        font-size: 0;
        line-height: 0;
        border-color: #ff0000 transparent transparent transparent;
        border-style: dashed dashed solid dashed;
        border-width: 6px;
    }
    .bubble::after{
        content: "";
        position: absolute;
        bottom: -11px;
        left: 6px;
        display: block;
        height: 0;
        width: 0;
        font-size: 0;
        line-height: 0;
        border-color: #fff transparent transparent transparent;
        border-style: dashed dashed solid dashed;
        border-width: 6px;
    }
    .bubble.grey{
        border: 1px solid #8c8c8c;
        color: #8c8c8c;
    }
    .bubble.grey::before{
        border-color: #8c8c8c transparent transparent transparent;
    }
    .bubble.green{
        border: 1px solid #109F00;
        color: #109F00;
    }
    .bubble.red{
        border: 1px solid red;
        color: red;
    }
    .bubble.green::before{
        border-color: #109F00 transparent transparent transparent;
    }

</style>
